module.exports = __webpack_public_path__ + "img/menu-service-info.01081900.svg";